import { Injectable, inject } from '@angular/core';
import { AXIOS_INSTANCE } from './api-client.tokens';

@Injectable({ providedIn: 'root' })
export class ApiClient {
  private readonly http = inject(AXIOS_INSTANCE);

  /**
   * Performs a GET request and returns the response body.
   */
  async get<T>(path: string): Promise<T> {
    const response = await this.http.get<T>(path);
    return response.data;
  }

  /**
   * Performs a JSON POST request and returns the response body.
   */
  async post<T>(path: string, body: unknown): Promise<T> {
    const response = await this.http.post<T>(path, body, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  }
}
